<template>
	<div class="chat" >
		<div v-if="topMsg.content" class="message-top">
			<div class="message">
				<img class="icon" src="./image/icon-top.png" />
				<div class="content">
					<!-- <span v-if="lengthFlag" class="role">{{ topMsg.name }}：</span>{{ topMsg.content }} -->
					<marquee-text :color="'#1e54d5'" :font-size="16" :speed="5" :height="30" :duration="30"
						>{{ topMsg.name }}：<span style="display: inline-block; min-width: 100px" v-html="topMsg.content.text"></span
					></marquee-text>
				</div>
			</div>
		</div>
		<div class="bubble-msg">
			<BubbleMsg :msgs="bubbleMsgs"></BubbleMsg>
		</div>
		<div  style="width: 100%;text-align: center;margin-top: 10px;" v-if="showmsg">没有更多消息了</div>
		<div ref="message" class="messages" @scroll="handleScroll" @touchmove="onTouchMove">
			<template v-for="(msg, index) in chatMsgs">
				<template v-if="msg.comment_type == messageType.speak">
					<div :key="'msg_' + index" class="msg">
						<div class="msg-normal">
							<div class="head"><img :src="msg.user.avatar" /></div>
							<div class="content">
								<div class="user">
									<div v-if="msg.user.user_type == '3'" class="role">直播助理</div>
									<div v-if="msg.user.user_type == '2'" class="role">主播</div>
									<div class="name">{{ msg.user.nick_name }}</div>
								</div>
								<div class="text" v-html="msg.content.text"></div>
							</div>
						</div>
					</div>
				</template>
				<template v-else-if="msg.comment_type == 'redpacket'">
					<div :key="'msg_' + index" class="msg">
						<red-packet :msg="msg" @clickRed="openRed"></red-packet>
						<!-- <div class="msg-normal">
							<div class="head"><img :src="msg.content.user.avatar" /></div>
							<div class="content">
								<div class="user">
									<div class="role" v-if="msg.content.user.user_type == '2'">直播助理</div>
									<div class="name">{{ msg.content.user.nick_name }}</div>
								</div>
								<div
									v-if="msg.has_send_out == null"
									class="redpacket"
									:style="{ opacity: msg.content.redpacket.surplus_num == 0 || msg.hasRecieved == true ? 0.5 : 1.0 }"
									@click="funsHandle(funcEvent.redpacket, msg.content)"
								>
									<div class="redpacket-content">
										<div class="redpacket-icon">
											<img src="./image/redpacket-icon.png" alt="" />
										</div>
										<div class="redpacket-desc">
											<div class="redpacket-title">{{ msg.content.redpacket.title }}</div>
											<div class="recieve" v-if="!msg.hasRecieved">
												{{ msg.content.redpacket.surplus_num == 0 ? "红包已被领完" : "领取红包" }}
											</div>
											<div class="recieve" v-if="msg.hasRecieved">{{ "已领取" }}</div>
										</div>
									</div>
									<div class="redpacket-type">{{ msg.content.redpacket.type == 1 ? "普通红包" : "口令红包" }}</div>
								</div>
								<div
									v-if="msg.has_send_out != null"
									class="redpacket"
									:style="{ opacity: msg.has_send_out == 1 || msg.hasRecieved == true ? 0.5 : 1.0 }"
									@click="funsHandle(funcEvent.redpacket, msg.content)"
								>
									<div class="redpacket-content">
										<div class="redpacket-icon">
											<img src="./image/redpacket-icon.png" alt="" />
										</div>
										<div class="redpacket-desc">
											<div class="redpacket-title">{{ msg.content.redpacket.title }}</div>
											<div class="recieve" v-if="!msg.hasRecieved">
												{{ msg.has_send_out == 1 ? "红包已被领完" : "领取红包" }}
											</div>
											<div class="recieve" v-if="msg.hasRecieved">{{ "已领取" }}</div>
										</div>
									</div>
									<div class="redpacket-type">{{ msg.content.redpacket.type == 1 ? "普通红包" : "口令红包" }}</div>
								</div>
							</div>
						</div> -->
					</div>
				</template>
				<template v-else-if="msg.comment_type == messageType.present">
					<div :key="'msg_' + index" class="msg notice">
						<div class="msg-gift" v-html="msg.content.text"></div>
					</div>
				</template>
				<template v-else-if="msg.comment_type == 'redpacketget'">
					<div :key="'msg_' + index" class="msg notice">
						<div class="msg-getred">
							<div class="red-img">
								<img src="./image/redpacket-icon.png" alt="" />
							</div>
							{{ msg.content.text }}
						</div>
					</div>
				</template>
				<template v-else-if="msg.comment_type == messageType.share">
					<div :key="'msg_' + index" class="msg notice">
						<div class="msg-share" v-html="msg.content.text"></div>
					</div>
				</template>
			</template>
		</div>
		<div v-if="noticeMsg" class="msg-notice">
			<div class="noticetitle">
				公告
				<van-icon name="cross" class="notice-close" @click="noticeClose" />
			</div>
			<div class="content" >
				<div v-html="noticeMsg"></div>
			</div>
		</div>
		<div class="message-funs">
			<div class="funs">
				<!-- 红包 -->
				<!-- <div class="item" v-if="isRedShow" @click="funsHandle(funcEvent.unopen)"><img src="./image/red-icon.png" /></div> -->
				<!-- 报名表 -->
				<!-- <div class="item" @click="funsHandle(funcEvent.entryForm)"><img src="./image/fun-icon-4.png" /></div> -->
				<!-- 抽奖 -->
				<div v-if="lotteryShow" class="item" @click="funsHandle(funcEvent.lottery)"><img src="./image/fun-icon-0.png" /></div>
				<!-- 邀请卡 -->
				<div class="item" v-if="(inviteShow || inviteShareShow) && !isApp" @click="funsHandle(funcEvent.invitationCard)"><img src="./image/fun-icon-1.png" /></div>
				<!-- 分享海报 -->
				<!-- <div class="item" v-if="inviteshareShow" @click="inviteNow"><img src="./image/fun-icon-1.png" /></div> -->
				<!-- 签到 -->
				<!-- <div class="item" @click="funsHandle(funcEvent.signIn)"><img src="./image/fun-icon-2.png" /></div> -->
				<!-- 点赞 -->
				<like-button ref="likeButton" :sources="likeEffects">
					<div class="item funs-like" @click="funsHandle(funcEvent.like)">
						<img src="./image/fun-icon-3.png" />
						<div class="like-count">{{ likeNum }}</div>
					</div>
				</like-button>
			</div>
		</div>
		<div class="operate">
			<div class="presenter">
				<input v-model="sendMessage" :disabled="muteState" placeholder="不想发点评论？" />
				<div v-if="muteState" class="mute-state"><img src="./image/operate-icon-0.png" /></div>
			</div>
			<div class="funs">
				<div class="funs-item" @click="giftEffectEnableHandle()">
					<img v-if="giftEffectEnable" src="./image/operate-icon-3.png" />
					<img v-if="!giftEffectEnable" src="./image/operate-icon-3-2.png" />
				</div>
				<GiftPresent :live_id="live_id" @present-gift="giftHandle">
					<div class="funs-item">
						<img src="./image/operate-icon-2.png" />
					</div>
				</GiftPresent>
				<div v-if="!sendMessage && !isApp" class="funs-item" @click="funsHandle(funcEvent.moreFunc)">
					<img src="./image/operate-icon-1.png" />
				</div>
				<div v-if="sendMessage" class="funs-item" @click="sendHandle()">
					<div class="btn-send">发送</div>
				</div>
			</div>
		</div>
		<div class="gift-animate"  v-show="svgaUrls.length">
			<svgaplayer :urls="svgaUrls"></svgaplayer>
		</div>
		<div class="gift-animates" v-show="presenturl" >
			<img :src="presenturl" ref="presentimage" class="zoom-fade" />
		</div>
	</div>
</template>
<script>
import * as api from '@/api/live'
import MarqueeText from "vue-marquee-text-component";
import BubbleMsg from "./component/bubble-msg.vue";
import svgaplayer from "./component/svga-player.vue";
import GiftPresent from "./component/gift-present.vue";
import redPacket from "./component/red-packet.vue";
import { gsap } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import likeButton from "./component/like-button.vue";
import { socketio,WSocketMessageType } from './socketio.js'

gsap.registerPlugin(MotionPathPlugin);

/** 功能事件 */
export const ChatFuncEvent = {
  /** 抽奖信息更新 */
  lotteryUpdated: 'lottery-updated',
  /** 抽奖获取 */
  lotteryOpened: 'lottery-opened',
//   打开抽奖
  lottery:'lottery',
	/** 签到 */
	signIn: "sign-in",
	/** 报名表 */
	entryForm: "entry-form",
	/** 邀清卡 */
	invitationCard: "invitation-card",
	/** 点赞 */
	like: "like",
	/** 更多功能 */
	moreFunc: "more-fun",
	/** 开播 */
	startLive: "start-live",
	/** 结束直播 */
	stopLive: "stop-live",
	/** 禁言 */
	shutUp: "shutUp",
	/** 取消禁言 */
	unShutUp:'unShutUp',
	/** 领取红包 */
	redpacket: "red-packet",
	/** 未领取红包 */
	unopen: "unopen-red",
	/** 领取红包通知 */
	getRed: "get-red",
	/** 观看数 */
	watch: "watch",
};

export default {
	props: {
		topMessage: {
			type: Object,
			default: null,
		},
		liveinfo:{
			type: Object,
			default: {}
		},
		redDetail: {
			type: Object,
			default: {
				user: {},
				redpacket: {},
			},
		},
		likeextra: 0,
		muteState: {
			type: Boolean,
			default: false,
		},
		lotteryShow: {
			type: Boolean,
			default: false,
		},
		inviteShow: {
			type: Boolean,
			default: false,
		},
		inviteShareShow: {
			type: Boolean,
			default: false,
		},
		isRedShow: {
			type: Boolean,
			default: false,
		},
		redremainId: {
			type: [String, Number],
			default: "",
		},
		live_id:{
			type: [String, Number],
		},
		user_id:{
			type: [String,Number],
		},
		isApp:{
			type: Boolean,
			default: false,
		}
	},
	components: { BubbleMsg, svgaplayer, GiftPresent, likeButton, MarqueeText,redPacket },
	data() {
		return {
			presenturl:"",
			messageType: WSocketMessageType,
			funcEvent: ChatFuncEvent,
			svgaUrls: [],
			topMsg: {}, // 置顶消息
			noticeMsg: "", // 公告
			bubbleMsgs: [], // 当前气泡消息
			chatMsgs: [], // 聊天区域消息 WSocketMessage[]: speak, gift, notice,
			chatMsgLimit: 1000,
			likeNum: 0,
			sendMessage: "",
			giftEffectEnable: true,
			test: Math.random(),
			likeEffects: ["like-effect/l-1.png", "like-effect/l-2.png", "like-effect/l-3.png", "like-effect/l-4.png"],
			messagePage:1,
			per_page:20,
			messageScroll:true,
			showmsg:false,
			istopmsg:false,
			isLoading:false,
			liketimer:null
		};
	},
	computed: {},
	watch: {
		redremainId(newV, oldV) {
			console.log(newV, "redremainId值更新");
			if (newV) {
				this.chatMsgs.forEach((item, index) => {
					if (item.type == "redpacket") {
						if (item.content.redpacket.id == newV&&newV!="") {
							console.log("更新的红包数据",item)
							item.content.redpacket.surplus_num = 0;
						}
					}
				});
			}
		},
		// liveinfo(newV){
		// 	//如果在直播中 持续点赞
		// 	if(newV.live_status == 2){
		// 		this.liketimer = setInterval(() => {
		// 		this.$refs.likeButton.add()
		// 		}, 400);
		// 	}
		// },

		topMessage(newV, oldV) {
			if (newV) {
				console.log('newV====', newV)
				this.topMsg = newV;
			}
		},
		isRedShow(newV, oldV) {
			if (newV) {
				this.isRedShow = newV;
			}
		},
		redDetail: {
			handler(newV, oldV) {
				console.log(newV.redpacket_id, "newV");
				if (newV.redpacket_id != null) {
					this.chatMsgs.forEach((item, index) => {
						if (item.type == "redpacket") {
							if (item.content.redpacket.id == newV.redpacket_id) {
								let redObject = JSON.parse(JSON.stringify(item));
								redObject.hasRecieved = true;
								this.chatMsgs.splice(index, 1, redObject);
								console.log(this.chatMsgs[index], "index");
							}
						}
					});
				}
			},

			deep: true,
		},
		likeextra(newV) {
			console.log("likeextra prop", newV);
			if (newV) {
				this.likeNum = newV;
			}
		},
	},
	beforeDestroy() {
		clearInterval(this.liketimer);
		
	},
	mounted() {
		window.chatVue = this

		if (this.likeextra > 0) {
			this.likeNum += this.likeextra;
		}
		setTimeout(() => {
			if (this.topMessage.content != "") {
				this.topMsg = this.topMessage;
				console.log('推荐评论信息', this.topMessage)
			}
		}, 1000);
		if(localStorage.getItem("noticeid") != this.live_id ){ //如果不是上次的直播，就清空
			localStorage.setItem("oldnoticeStorage",'')
			localStorage.setItem("noticeStorage",'')
		}else{
			this.noticeMsg = localStorage.getItem("noticeStorage")
		}
		this.getnotice()
	},
	methods: {
		onTouchMove(event){
			event.stopPropagation();
		},
		getmessages(type){
			if (this.isLoading) {
				return;
			}
			this.isLoading = true;
			api.historymessages({live_id:this.live_id,page:this.messagePage,per_page:this.per_page}).then((res) => {
				if(res.code != 200){
					this.$toast({
						message: '获取历史消息失败',
						type: 'error',
						duration: 1500
					})
					return false
				}
				this.chatMsgs.unshift(...res.result.data.reverse())
				this.isLoading = false;
				if(type){
					this.$refs.message.scrollTop = 150
				}
				if(res.result.data.length <20 || !res.result.data.length){
					this.messageScroll = false
				}
			})
    	},
		handleScroll(e){//滚动到顶部加载历史消息
			let element = e.target;
			if (element.scrollTop != 0) {
				return false
			}
			if(this.messageScroll){
				this.messagePage ++
				this.getmessages(1)

			}else{
				if(this.istopmsg){
				return false
				}
			this.showmsg = true
			this.istopmsg = true
			setTimeout(() => {
				this.showmsg = false
			}, 1500);
			}

    	},
		getnotice(){
			api.getnotice({live_id: this.live_id}).then((res) => {
				if(res.result != null && res.result.notice != localStorage.getItem("oldnoticeStorage") ){
					this.noticeMsg  = res.result.notice
					localStorage.setItem("noticeStorage", res.result.notice );
					localStorage.setItem("oldnoticeStorage", res.result.notice );
					localStorage.setItem("noticeid", this.live_id);
				}

			})
		},
		funsHandle(event, data) {
			if (!localStorage.getItem('live_access_token') && event != "watch") {
				this.$emit('login');
				return;
			}
			console.log("funsHandle:", event);
			if (event === this.funcEvent.like) {
				this.likeHandle();
			} else {
				this.$emit(event, data);
			}
		},
		giftEffectEnableHandle() {
			this.giftEffectEnable = !this.giftEffectEnable;
		},
		giftHandle(obj) {
			const param = {
				live_id:this.live_id,
				present_id: obj.gift.id,
				send_num: obj.count,
				receiver_id: obj.anchor.user_id
			}
      		socketio.socketsend('present',param)
		},
		likeHandle() {
			const param = {
				user_id: this.user_id,
				live_id: this.live_id,
			}
      		socketio.socketsend('like',param)
			this.$refs.likeButton.add();
		},
		noticeClose() {
			this.noticeMsg = ''
      		localStorage.setItem("noticeStorage",'');
		},
		openRed(data){
      		this.funsHandle(this.funcEvent.redpacket,data)
		},
		sendHandle() {
      if (!localStorage.getItem('live_access_token')) {
        this.$emit('login');
        return;
      }
			const reg = /<script[^>]*>([\S\s]*?)<\/script>/gim;
			if (reg.test(this.sendMessage)) {
				this.sendMessage = this.sendMessage.replace(reg, "【非法字符】");
			}
			const params = {
				user_id: this.user_id,
				live_id: this.live_id,
				content: this.sendMessage
			}
			socketio.socketsend('speak',params)
			this.sendMessage = "";
		},
		//入场
		entryFormHandle(data) {
			this.bubbleMsgs = [data]
		},
		receiveHandle(data) {
			switch (data.type) {
				// case this.messageType.login:
				// 	this.bubbleMsgs = [data];
				// 	setTimeout(() => {
				// 		this.$refs.message.scrollTop = this.$refs.message.scrollHeight;
				// 	}, 500);
				// 	break;
				case this.messageType.top:
					this.topMsg = data;
					console.log('推荐内容====', data)
					break;
				case this.messageType.likeNumUpdate:
					this.likeNum = data.like_num;
					break;
				case this.messageType.notice:
					var newNotice = decodeURIComponent(data.content);
					this.noticeMsg = newNotice;
          localStorage.setItem("noticeStorage", newNotice );
					localStorage.setItem("oldnoticeStorage", newNotice );
					localStorage.setItem("noticeid", this.live_id);
					console.log('data', data)
					break;
				case this.messageType.lotteryOpened:
					this.funsHandle(this.funcEvent.lotteryOpened, data)
					break
				case this.messageType.lottery:
				this.funsHandle(this.funcEvent.lottery, data)
				case this.messageType.lotteryUpdated:
					this.funsHandle(this.funcEvent.lotteryUpdated, data.content)
					break
				case this.messageType.startLive:
					this.funsHandle(this.funcEvent.startLive);
					break;
				case this.messageType.stopLive:
					this.funsHandle(this.funcEvent.stopLive);
					break;
				case this.messageType.shutUp:
					this.funsHandle(this.funcEvent.shutUp, data);
					break;
				case this.messageType.unShutUp:
					this.funsHandle(this.funcEvent.unShutUp, data);
					break;
				case this.messageType.refusal:
					this.chatMsgs = this.chatMsgs.filter((item) => item.id != data.comment_id);
					// 防止页面的数据没更新
					this.chatMsgs = [...this.chatMsgs];
					break;
				case this.messageType.watchNumUpdate:
					this.funsHandle(this.funcEvent.watch, data);
				case 'redPacketUpdated':
					// this.isRedShow = data.red_packet_show
					this.$emit('update:isRedShow',data.red_packet_show)
					break;
				default:
					
					break;
			}
		},
		//接收聊天消息
		getmessage(data,messagetype){
			if(messagetype == 'history'){  
				this.chatMsgs.push(...data.messages)
				// 去除id重复的聊天记录
				const seenIds = new Set(); 
				const uniqueById = this.chatMsgs.filter(item => {  
					if (!seenIds.has(item.id) && item.live_id == this.live_id) {  
						seenIds.add(item.id);  
						return true;  
					}  
					return false;  
				});
				this.chatMsgs = uniqueById
				this.chatMsgs.reverse();
				setTimeout(() => {
					this.$nextTick(() => {this.$refs.message.scrollTop = this.$refs.message.scrollHeight});
				}, 500);
			}else{
				if (data.live_id == this.live_id) {
					this.chatMsgs.push(data)
				}    
				this.$nextTick(() => {this.$refs.message.scrollTop = this.$refs.message.scrollHeight+100 });
			}

			if (data.comment_type === 'redpacket') {
				this.funsHandle(this.funcEvent.getRed, data.content.redpacket.id)
			}
			if (messagetype == 'history') {
				return
			}
			if (data.comment_type === 'redpacketget') {
				this.funsHandle(this.funcEvent.getRed, data.content.redpacket_id)
			}
			if (this.giftEffectEnable && data.comment_type == this.messageType.present && data.content.present.url) {
				if(data.content.present.live_pic == undefined){
					this.svgaUrls = []
					this.presenturl = data.content.present.url
					this.triggerAnimation();
				}else{
					this.svgaUrls = [data.content.present.live_pic] 
					this.presenturl = ''
				}

				// data.content.present.live_pic == undefined ? this.svgaUrls = [] : this.svgaUrls = [data.content.present.live_pic] 
				// this.presenturl = data.content.present.url
				// if(!this.svgaUrls.length){
				// 	this.triggerAnimation();
				// }
			}
		},
		scrollAutoBottom() {
			const lastDom = this.$refs.message.lastElementChild;
			
			if (lastDom) {
				if (this.$refs.message.scrollTop + this.$refs.message.clientHeight > this.$refs.message.scrollHeight - (lastDom.clientHeight + 30)) {
					this.$refs.message.scrollTop = this.$refs.message.scrollHeight;
				}
			}
			
		},
		getRandom(min, max) {
			return Math.round(Math.random() * (max - min)) + min;
		},
		triggerAnimation() {
			this.$nextTick(() => {
				const image = this.$refs.presentimage;
				image.classList.remove('zoom-fade'); // 移除动画类
				void image.offsetWidth; // 强制重绘
				image.classList.add('zoom-fade'); // 重新添加动画类
			});
		}
	},
};
</script>

<style lang="less" scoped>
@import "./chat.less";
.chat {
	.bubble-msg {
		// position: absolute;
		// top: 10px;
		// left: 0;
		width: 100%;
    	overflow: hidden;
	}
	// .flex-c-sb-r-start;
	width: 100%;
	height: 100%;
	position: relative;
	// -webkit-overflow-scrolling: touch;
	// overflow-y: scroll;
	> .message-top {
		width: 100%;
		height: auto;
		padding: 15px 10px 10px 10px;
		> .message {
			.flex-r-start-c-start;
			> .icon {
				width: 13px;
				height: auto;
			}
			> .content {
				margin-left: 10px;
				color: #1e54d5;
				text-align: justify;
				.role {
					font-weight: bold;
				}
			}
		}
	}
	> .messages {
		.flex-c-start-r-start;
		width: 100%;
		// height: 0;
		height: 400px;
		// flex-grow: 1;
		overflow-y: scroll;
		-webkit-overflow-scrolling: touch;
		// touch-action: pan-y;
		padding: 10px 15px 10px;
		// height: auto;
		padding-bottom:60px;
		> .msg {
			width: 100%;
			&:nth-child(n + 2) {
				margin-top: 15px;
			}
			&.notice {
				.flex-r-center-c-center;
			}
		}
		.msg-normal {
			width: 88%;
			height: auto;
			.flex-r-start-c-start;
			> .head {
				width: 36px;
				height: 36px;
				border-radius: 32px;
				border: 1px solid #434043;
				overflow: hidden;
			}
			> .content {
				width: 0;
				flex: 1;
				margin-left: 10px;
				.flex-c-start-r-start;
				> .user {
					.flex-r-start-c-center;
					> .role {
						background-color: #00abea;
						padding: 4px 5px 3px 5px;
						border-radius: 2px;
						color: #fff;
						font-size: 10px;
						line-height: 1;
						margin-right: 5px;
					}
					> .name {
						font-size: 14px;
						font-weight: 600;
					}
				}
				> .text {
					background-color: #e6f0ff;
					text-align: justify;
					padding: 8px 10px;
					border-radius: 3px;
					margin-top: 6px;
					word-break: break-all;
				}
				> .redpacket {
					margin-top: 6px;
					width: 225px;
					height: 85px;
					border-radius: 3px;
					background: url("./image/redpacket-bg.png");
					background-size: 100% 100%;
					> .redpacket-content {
						display: flex;
						box-sizing: border-box;
						margin-left: 10px;
						margin-right: 10px;
						width: calc(100% - 20px);
						padding-bottom: 12px;
						border-bottom: 1px solid rgba(255, 255, 255, 0.1);
						> .redpacket-icon {
							margin-top: 9px;
							width: 37px;
							height: 42px;
							> img {
								width: 100%;
								height: 100%;
							}
						}
						> .redpacket-desc {
							margin-left: 12px;
							margin-top: 14px;
							> .redpacket-title {
								width: 150px;
								font-size: 14px;
								font-weight: bold;
								color: #fff;
								text-align: left;
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
							}
							> .recieve {
								margin-top: 8px;
								font-size: 10px;
								color: #fff;
								text-align: left;
							}
						}
					}
					> .redpacket-type {
						flex: 1;
						display: flex;
						margin-left: 12px;
						align-items: center;
						text-align: left;
						font-size: 10px;
						color: #fff;
						text-align: left;
					}
				}
			}
		}
		.msg-getred {
			.flex-r-center-c-center;
			width: max-content;
			height: auto;
			font-weight: bold;
			background-color: #ffe7e7;
			border-radius: 20px;
			font-size: 11px;
			padding: 6px 20px;
			line-height: 1;
			color: #ff5757;
			> .red-img {
				width: 18px;
				height: 18px;
				margin-right: 5px;
				> img {
					width: 100%;
					height: 100%;
				}
			}
		}

		.msg-gift {
			.flex-r-center-c-center;
			width: max-content;
			height: auto;
			background-color: #fff5f4;
			border-radius: 5px;
			padding: 2px 20px;
			line-height: 1;
			color: #bd0e00;
			font-weight: 300;
			font-size: 12px;
			::v-deep .git-image {
				width: 22px !important;
				object-fit: fill;
			}
		}
		.msg-share {
			.flex-r-center-c-center;
			width: max-content;
			height: auto;
			background-color: #fff5f4;
			border-radius: 5px;
			padding: 2px 20px;
			color: #bd0e00;
			font-weight: 300;
			line-height: 1;
			font-size: 12px;
		}
	}
	> .msg-notice {
		.flex-c-center-r-center;
		align-items: initial;
		position: absolute;
		top: 10px;
		left: 50%;
		width: 98%;
		height: auto;
		// padding: 8px;
		z-index: 99;
		background-color: #e6f0ff;
		transform: translate(-50%,0);
		border-radius: 7px;
		> .content {
			height: max-content;
			padding: 8px 25px 8px 15px;
			// background-color: #c8eaff;
			color: #000;
			text-align: justify;
			position: relative;
			// border-radius: 5px;
			line-height: 1.5;
		}
		.notice-close {
			position: absolute;
			top: 4px;
			right: 4px;
		}
		.noticetitle{
			width: 100%;
			text-align: center;
			height: 35px;
			border-bottom: 1px solid #fff;
			font-size: 16px;
			line-height: 35px;
		}
	}
	> .message-funs {
		position: fixed;
		bottom: 70px;
		right: 15px;
		> .funs {
			.flex-c-end-r-center;
			> .item {
				&:nth-last-child(n-2) {
					margin-top: 18px;
				}
				width: 40px;
				height: 40px;
				position: relative;
			}
			.funs-like {
				margin-top: 18px;
				width: 40px;
				height: 40px;
				position: relative;
				> .like-count {
					background-color: #fbc200;
					border-radius: 5px;
					box-sizing: border-box;
					padding: 0 5px;
					position: absolute;
					top: 0;
					left: 50%;
					transform: translateX(-50%);
					font-size: 12px;
					color: #dc1200;
					text-align: center;
				}
			}
		}
	}
	> .operate {
		width: 100%;
		height: 47.5px;
		padding: 6px 10px;
		background-color: #e6f0ff;
		border-top: 1px solid #cdcdcd;
		flex-shrink: 0;
		.flex-r-sb-c-center;
		position: fixed;
		bottom: 0;
		.presenter {
			width: 0;
			flex: 1;
			height: 100%;
			position: relative;
			> input {
				width: 100%;
				height: 100%;
				border-radius: 100px;
				background-color: #fff;
				border: 0;
				padding: 0 20px 0 15px;
				&:disabled {
					background-color: #e2e2e2;
					padding: 0 46px 0 15px;
				}
			}
			.mute-state {
				width: 24px;
				height: 24px;
				position: absolute;
				top: 50%;
				right: 15px;
				transform: translateY(-50%);
			}
		}
		> .funs {
			.flex-r-end-c-center;
			margin-left: 5px;
		}
		.funs-item {
			.flex-r-center-c-center;
			width: 30px;
			height: 24px;
			img {
				width: 24px !important;
				height: 24px !important;
			}
			&:nth-last-child(n-2) {
				margin-left: 12px;
			}
			.btn-send {
				color: #1ab4ec;
			}
		}
	}
	> .gift-animate {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		pointer-events: none;
		overflow: hidden;
	}
	>.gift-animates {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    overflow: hidden;
    text-align: center;
    .zoom-fade {
      animation: zoomFade 1.5s forwards;
      object-fit: contain;
    }
    @keyframes zoomFade {
      0% {
        transform: scale(1);
        opacity: 1;
      }
      50% {
        transform: scale(1.1);
        opacity: 1;
      }
      100% {
        transform: scale(1.1);
        opacity: 0;
      }
    }
  }
}
</style>
